import { Component, OnInit, EventEmitter,Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from '../../services/ist/ist-summary.service';
import { httpOptions, serviceConstants } from '../../constants/service.constants';
import { IstDataShareService } from '../../services/ist/ist-datashare.service';
import { MessageBoxComponent } from '../message-box/message-box.component';
import { Subject } from 'rxjs';
import { Document_Upload_File } from '../../models/common';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-attachment-classification',
  templateUrl: './attachment-classification.component.html',
  styleUrls: ['./attachment-classification.component.scss']
})
export class AttachmentClassificationComponent implements OnInit {

  @Input() public Content: any;
  documentOptionsConstant = [];
  content: any;
  heading: string;
  files: any[];
  uploadedFiles = [];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  ApplicationID: any;
  AttachmentForm: UntypedFormGroup;
  Classification: any;
  document_attach_list: Document_Upload_File[] = [];
  action: Subject<any> = new Subject();

  constructor(public modalRef: NgbActiveModal,
    private summaryService: IstSummaryService,
    private datashareService: IstDataShareService,
    private modalService: NgbModal,
    public datepipe: DatePipe,
    private commonService: CommonService,
  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
  }

  ngOnInit() {
    debugger;
    this.AttachmentForm = new UntypedFormGroup({
      Classification: new UntypedFormControl("")
    })
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.files = [];
    this.getMasterDropDown();
  }

  getMasterDropDown() {
    this.summaryService.masterData("api/ISTFileAttachments/GetAttachClass?ModuleName=" + this.Content.content.ModuleName).subscribe(result => {
      this.documentOptionsConstant = result["MasterData1"];
      this.documentOptionsConstant = [{label:"Select",value:"", checked: true}].concat(this.documentOptionsConstant);
    });
  }

  showFiles() {
    let files = '';
    this.uploadedFiles = [];

    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }
    }
    for (let i = 0; i < this.files.length; i++) {
      let newAttachment = this.files[i].name;
      this.uploadedFiles.push(newAttachment);
    }
    return files;
  }

  DeleteUpload(file): void {
    if (file.Status == "Add") {
      let code = file.ID;
      // this.documaent_attach_list = this.documaent_attach_list.filter(function (sec) {
      //   return sec.ID != code;
      // }, code);      
      let index = this.document_attach_list.findIndex(x => x.ID == file.ID);
      this.document_attach_list.splice(index, 1);
    }
    else {
      file.Status = "Delete";
    }
  }

  SaveUploadAttachment(): void {
    let isValid = true;
    let Message = "";
    let Classification1 = this.AttachmentForm.controls["Classification"].value;

    if (this.Content.is_ac_display && this.Content.is_ac_mand){
      if (Classification1 === null || Classification1 === "" || Classification1 === undefined) {
        $("#Classification").addClass("ng-touched ng-invalid validate-error");
        $("#Classification").removeClass("ng-untouched ng-valid");
        isValid = false;
        Message += `Please select ${this.Content.ac_label} <br/>`;
      } else {
        $("#Classification").addClass("ng-untouched ng-valid");
        $("#Classification").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.Content.is_file_display && this.Content.is_file_mand){
      if (this.document_attach_list == null || this.document_attach_list.length == 0) {
        isValid = false;
        Message += `Please upload ${this.Content.file_lable} <br/>`;
      }
    }

    if (!isValid) {
      this.commonService.ValidationBanner(Message);
    }
    else {
      let ClasificationName = "";
      var DFobj = this.documentOptionsConstant.filter(function (element) {
        return element.value == Classification1;
      })[0];
      if (DFobj != null && DFobj != undefined) {
        ClasificationName = DFobj.label;
      }

      var formData = new FormData();
      if (this.document_attach_list != null && this.document_attach_list.length > 0) {
        for (let i = 0; i < this.document_attach_list.length; i++) {
          formData.append(("" + (i + 1)), this.document_attach_list[i].File);
        }       
      }
      
      let fileData = [];
      let sameFiles = [];
      let hasSame: boolean = false;
      let findItem;
      if(this.document_attach_list.length > 0){
        this.summaryService.FilesInsert("api/ISTFileAttachments/UploadAttachmentGrid", formData).subscribe(summary => {
          summary.forEach((item: any) => {
            let obj = {
              "AttachmentClassificationId": Classification1,
              "AttachmentClassification": ClasificationName,
              "FileID": item.value,
              "FileName": item.label,
              "Date": this.datepipe.transform(new Date(), 'dd-MMM-yyyy'),
              "Status": "Add"
            };
  
            findItem = fileData.find(x => x.FileName == item.label);
  
            if(this.Content.content.filesList?.length > 0){
              findItem = this.Content.content.filesList.filter(x=> x.FileName?.toLowerCase() == item.label.toLowerCase() && x.AttachmentClassification.toLowerCase() == ClasificationName.toLowerCase());
              findItem = findItem[0];
            }
  
            if (findItem == null) {
              fileData.push(obj);
            } else {
              sameFiles.push(findItem.FileName);
              hasSame = true;
            }
          });
  
          if(hasSame){
            this.commonService.ValidationBanner("File already exists with " + sameFiles.join(', ') + " Please update the unique file name");
          } 
  
          if (!hasSame) {          
            this.modalRef.close(fileData);
          }
        });
      } else{
            let obj = {
              "AttachmentClassificationId": Classification1,
              "AttachmentClassification": ClasificationName,              
              "Date": this.datepipe.transform(new Date(), 'dd-MMM-yyyy'),
              "Status": "Add"
            }; 
            
          let hasName =  this.Content.content.filesList.filter(x=> x.AttachmentClassificationId == this.AttachmentForm.controls["Classification"].value 
                          && x.FileName == null );
          if(hasName.length > 0){          
            hasSame = true;
          } else{
            fileData.push(obj);
          }
         
          if (!hasSame) {          
            this.modalRef.close(fileData);
          }  else{
            this.commonService.ValidationBanner("Attachment classification exists with " + obj.AttachmentClassification);

          }
      }     
    }
  }

  /* uploadchange(event): void {
    let id : any[] = [];
    if (this.documaent_attach_list == undefined || this.documaent_attach_list == null) {
      this.documaent_attach_list = [];
    }

    var file = event.target.files[0].name;
    var ext = file.match(/\.([^\.]+)$/)[1];
    var filesize = event.target.files[0].size;
    if (file != null && ((filesize > (1024 * 1024 * 10)) || (ext != 'docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext!= 'pdf'))) {
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
      //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: "Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB" } } });
    }
    else {
      for (let i = 0; i < event.target.files.length; i++) {
        let uploadFile = new Document_Upload_File();
        this.documaent_attach_list.forEach((ele: any)=> {
          id.push(ele.ID);
        });
        if(id.length == 0){
          uploadFile.ID = ("" + (1));
        } else{
        let maxId = Math.max(...id);
          uploadFile.ID = ("" + (maxId + 1));
        }
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
       let fileExist = this.documaent_attach_list.filter(x=>x.DOCUMENT_NAME.toLowerCase() == event.target.files[i].name.toLowerCase())
        if(fileExist.length <= 0){
          this.documaent_attach_list.push(uploadFile);
        } else{
          this.commonService.ValidationBanner("File already exists with " + event.target.files[i].name + " Please update the unique file name");
          //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'File already exists with ' + event.target.files[i].name + ' Please update the unique file name' } } });
        }
      }
    }
  } */

  uploadchange(event): void {
    if (this.document_attach_list == undefined || this.document_attach_list == null) {
      this.document_attach_list = [];
    }
    let hasUnFormat = false;
    let hasMultipleFiles = false;
    let Duplicate_File_List = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;   
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && ((filesize > 15728640) || (ext !='docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) 
      {        
        hasUnFormat = true;
      }
      else 
      {
        uploadFile.ID = this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        let hasValue = [];
        let hasFile = [];
        if(this.Content.content.filesList?.length > 0)
        {
          if(this.AttachmentForm.controls["Classification"].value != null && this.AttachmentForm.controls["Classification"].value != ""){
            hasValue = this.Content.content.filesList.filter(x=> x.FileName?.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.AttachmentClassificationId == this.AttachmentForm.controls["Classification"].value);
          } 
          else{
            hasValue = this.Content.content.filesList.filter(x=> x.FileName?.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
          }
        } 

        
        if(uploadFile.DOCUMENT_NAME != null && uploadFile.DOCUMENT_NAME != undefined){
          hasFile = this.document_attach_list.filter(x=> x.DOCUMENT_NAME?.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        }        

        if(hasValue.length > 0 || hasFile.length > 0)
        {
          hasMultipleFiles = true;
          Duplicate_File_List.push(uploadFile.DOCUMENT_NAME);
        } else
        {
          if (this.Content.is_multiple_files){
            this.document_attach_list.push(uploadFile);
            } else {
              this.document_attach_list =[];
              this.document_attach_list.push(uploadFile);
            }
        }
      }
    }
    
    if(hasUnFormat){
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB"); 
    }

    if(hasMultipleFiles){
      this.commonService.ValidationBanner("File already exists with " + Duplicate_File_List.join(', ') + ". Please update the unique file name");
    }
  }

  onUploadOutput(output: any | any): void {
    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      this.files = [];
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    //this.showFiles();

  }
}
